import { useState, useEffect, useMemo } from 'react';
import { api } from '../api';
import toast from 'react-hot-toast';
import NavIcon from '../components/NavIcon';
import { confirmDialog } from '../components/ConfirmDialog';

function Modal({ cat, onClose, onSave }) {
  const [form, setForm] = useState(cat || { name: '', description: '' });
  const set = (k, v) => setForm(f => ({ ...f, [k]: v }));
  const save = async () => {
    if (!form.name.trim()) return toast.error('Name is required');
    try {
      if (cat?.id) await api.updateCategory(cat.id, form);
      else await api.createCategory(form);
      toast.success(cat?.id ? 'Category updated' : 'Category created'); onSave();
    } catch { toast.error('Failed to save'); }
  };
  return (
    <div className="modal-overlay"><div className="modal">
      <div className="modal-header"><h3>{cat?.id ? 'Edit Category' : 'New Category'}</h3><button className="btn btn-secondary btn-sm" onClick={onClose}>✕</button></div>
      <div className="form-row"><div className="field"><label>Name *</label><input value={form.name} onChange={e => set('name', e.target.value)} placeholder="e.g. Beverages" /></div></div>
      <div className="field"><label>Description</label><textarea value={form.description || ''} onChange={e => set('description', e.target.value)} rows={2} placeholder="Optional description" /></div>
      <div className="modal-footer"><button className="btn btn-secondary" onClick={onClose}>Cancel</button><button className="btn btn-primary" onClick={save}>Save Category</button></div>
    </div></div>
  );
}

export default function Categories() {
  const [cats, setCats]   = useState([]);
  const [modal, setModal] = useState(null);
  const [search, setSearch] = useState('');

  const load = () => api.getCategories().then(setCats);
  useEffect(() => { load(); }, []);

  const filtered = useMemo(() =>
    cats.filter(c => !search || c.name.toLowerCase().includes(search.toLowerCase()) || (c.description || '').toLowerCase().includes(search.toLowerCase())),
    [cats, search]
  );

  const toggleActive = async (c) => {
    const next = !c.isActive;
    const verb = next ? 'reactivate' : 'deactivate';
    if (!(await confirmDialog(`Are you sure you want to ${verb} "${c.name}"?${next ? '' : ' It will no longer be selectable for products, but stays visible in past reports.'}`, { danger: !next, confirmText: verb.charAt(0).toUpperCase() + verb.slice(1) }))) return;
    try {
      await api.setCategoryActive(c.id, next);
      toast.success(next ? 'Category reactivated' : 'Category deactivated');
      load();
    } catch { toast.error('Failed to update'); }
  };

  return (
    <div>
      <div className="flex-between mb-6">
        <div className="page-header" style={{margin:0}}><h2>Categories</h2><p>Organise your products into categories</p></div>
        <button className="btn btn-primary" onClick={() => setModal('new')}>+ New Category</button>
      </div>
      <div className="card">
        <div className="filter-bar">
          <input placeholder="Search categories…" value={search} onChange={e => setSearch(e.target.value)} />
          <div className="filter-spacer"/>
          <span className="filter-results">{filtered.length} of {cats.length}</span>
        </div>
        {filtered.length === 0 ? (
          <div className="empty-state"><div className="icon"><NavIcon name="categories" size={32} /></div><div>No categories found.</div></div>
        ) : (
          <div className="table-wrap"><table>
            <thead><tr><th>#</th><th>Name</th><th>Description</th><th>Status</th><th></th></tr></thead>
            <tbody>
              {filtered.map(c => (
                <tr key={c.id} style={c.isActive ? undefined : { opacity: 0.55 }}>
                  <td className="mono text-muted" data-label="#">{c.id}</td>
                  <td style={{fontWeight:600}} data-label="Name">{c.name}</td>
                  <td className="text-muted" data-label="Description">{c.description || '—'}</td>
                  <td data-label="Status">
                    <span className={`badge ${c.isActive ? 'badge-active' : 'badge-inactive'}`}>
                      {c.isActive ? 'Active' : 'Inactive'}
                    </span>
                  </td>
                  <td data-label=""><div className="flex gap-2">
                    <button className="btn btn-secondary btn-sm" onClick={() => setModal(c)}>Edit</button>
                    <button
                      className={`btn btn-sm ${c.isActive ? 'btn-danger' : 'btn-secondary'}`}
                      onClick={() => toggleActive(c)}
                    >
                      {c.isActive ? 'Deactivate' : 'Reactivate'}
                    </button>
                  </div></td>
                </tr>
              ))}
            </tbody>
          </table></div>
        )}
      </div>
      {modal && <Modal cat={modal === 'new' ? null : modal} onClose={() => setModal(null)} onSave={() => { setModal(null); load(); }} />}
    </div>
  );
}
